import { useAppSelector, useAppDispatch } from "../hooks";
import Navbar from "../assets/navbar";
import { Navigate } from "react-router-dom";
import {
  Flex,
  Input,
  Center, 
  Button,
  InputGroup,
  Stack,
  List,
  ListItem,
  ListIcon,
  InputLeftElement,
  chakra,
  Spacer,
  Box,
  OrderedList,
  InputRightElement,
  Alert,
  AlertIcon,
  Image,
  Text,
  Badge,
} from "@chakra-ui/react";
import { selectUser } from "../reducers/userSlice";
import { selectAdmin, requestSignupKey, requestReset } from "../reducers/adminSlice";
function InfoText(){
  const aauColor = "#211a52";
  return (
    <>
    
    
    <Text fontSize='20px'>The admin user is only intended to be used for the following actions: </Text>

    <OrderedList>
      <ListItem fontSize="20px"> Generate a signup key for participants by clicking the "Request Signup Key" button. </ListItem>
      <ListItem fontSize="20px"> Reset the platform by clicking the "Request Reset" button. This will clean up the database and reset all VM's for later use. </ListItem>
      </OrderedList>
      <Text fontSize='20px'> The admin user will therefore not have access to the virtual machines and the settings page.</Text>    
    </>
  )
}



function Alerts() {
  const admin = useAppSelector(selectAdmin);
  if (admin.error !== ''){
    return (
      <>
      <Alert status="error" borderRadius='lg' mt='20px'>
        {admin.error}
      </Alert>
      </>
    )
  }
  return (
  <>
    <Text as='b'> </Text>
  </>
  )

}

function SignupKeyGen() {
  const aauColor = "#211a52";
  const adminData = useAppSelector(selectAdmin);
  const dispatch = useAppDispatch();

  const signupKeyHandler = () => {
    let payload = {
      access_token:localStorage.getItem("access_token"),
    };
    let payloadJSON = JSON.stringify(payload);
    
    dispatch(requestSignupKey(payloadJSON));
  }


  let signupkeyButtonColor = ""; 
  
  let signupKeyGen = adminData.signupKey;
  signupkeyButtonColor= aauColor;
  


  return (
    <>
      <Stack direction="row" alignItems="center">
        <Button onClick={signupKeyHandler} bg={signupkeyButtonColor} color="white">Request Signup Key</Button>
        <Text fontSize='20px'>Signup Key: {signupKeyGen}</Text>
      </Stack>
      {/* <Button onClick={() => dispatch(infectVM())} bg={isInfectedColor} color="white">Infect</Button> */}
    </>
  );
}

function ResetButton() {
  const aauColor = "#211a52";
  const adminData = useAppSelector(selectAdmin);
  const dispatch = useAppDispatch();

  const resetHandler = () => {
    let payload = {
      // access_token:localStorage.getItem("access_token"),
    };
  
    let payloadJSON = JSON.stringify(payload);
    
    dispatch(requestReset(payloadJSON));
  }


  let resetButtonColor = ""; 
  
  let status = adminData.status;
  resetButtonColor= aauColor;
  
  if (adminData.status === "Resetting system") {
    return (
      <>
      <Stack direction="row" alignItems="center">
        <Button isLoading bg={resetButtonColor} color="white" loadingText='Cleaning'>Request Reset</Button>
        <Text fontSize='20px'>Backend Status: {status}</Text>
      </Stack>
    </>
    )
  }

  return (
    <>
      <Stack direction="row" alignItems="center">
        <Button onClick={resetHandler} bg={resetButtonColor} color="white">Request Reset</Button>
        <Text fontSize='20px'>Backend Status: {status}</Text>
      </Stack>
    </>
  );
}

//TODO Request vm knap.

export default function AdminPage() {
  const aauColor = "#211a52";
  const user = useAppSelector(selectUser);

  if (user.loggedIn !== true) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Navbar />

      <Flex
        flexDirection="column"
        width="100%"
        height="85vh"
        // justifyContent="center"
        alignItems="center"
        marginBottom="100px"
      >
        <Box m="20px">
          <Text
            marginBottom="10px"
            fontSize="30px"
            fontWeight="bold"
            color="#211a52"
          >
            Admin Page
          </Text>
        </Box>
        <Box>

        
        <Box borderWidth='2px' borderRadius='lg' borderColor={aauColor} bg="blue.50">
        
        <Flex flexDirection="row" gap="20px">
                  <Flex gap={3} flexDirection="column" m="10px">
                    <InfoText/>
                    <SignupKeyGen />  
                    <ResetButton />
                  </Flex>
                  
                  
                  
                </Flex>        
        
        </Box>
        <Alerts/>
        </Box>
      </Flex>
    </>
  );
}
